var _rect, _rect2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.952936,
    height: 12.57213,
    rx: 1,
    ry: 1,
    transform: "matrix(.957236 0 0 1.144012 3.236346 0.808666)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.952936,
    height: 12.57213,
    rx: 1,
    ry: 1,
    transform: "matrix(.733553 0 0 0.810675 4.349497 2.085544)",
    fill: "none",
    stroke: "#000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -1.014938,
    y1: 0,
    x2: 0.485062,
    y2: 0,
    transform: "matrix(1.309959 0 0 1 8.347058 13.783506)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.aff7926a53e42302c763b458bf0be6be.svg";
export { ForwardRef as ReactComponent };